import React, { useEffect, useRef, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import "./ShiftCreation.css";
import useHttp from "../../../Hooks/use-http";
import { GrFormNext } from "react-icons/gr";
// import DatePicker from "react-multi-date-picker";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import { MdEdit } from "react-icons/md";
import transition from "react-element-popper/animations/transition";
import ShiftMap from "./ShiftMap";
import loadingGif from "../../../Assets/loading-gif.gif";
import Message from "../../../Modal/Message";
import { AiOutlineConsoleSql, AiOutlineDelete } from "react-icons/ai";
import { useLocation } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

import { useHistory } from "react-router-dom";

import {
  TextField,
  Checkbox,
  FormControlLabel,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
} from "@mui/material";
import {
  svgMarkerForEndLocation,
  svgMarkerForStartLocation,
} from "../../../Constant";
import { ExtractLatLng } from "../../CommonComponent/ExtractLatLng";
import CustomButton from "./CustomButton";
import CustomCalender from "./CustomCalender";

let corporates;
// let drivers;
let selectedDepartment = {};
let selectedDrivers = []; // Changed to array for multiple drivers
// var autocomplete = "";
var autocomplete = [];
// let shiftData = [];
let marker;
let map;
let shiftStartOtpFromConfig;
let shiftEndOtpFromConfig;
let errorFileds = {
  coprorateNameError: "",
  departmentNameError: "",
  driverNameError: "",
  roMobileError: "",
  rpLocationError: "",
  shiftTimingsError: "",
};
let shiftId = "";
let startLocationMarker;
let endLocationMarker;
let startLatLng;
let endLatLng;

const ShiftCreation = () => {
  const corporateNameRef = useRef();
  const [driverDetails, setDriverDetails] = useState([]); //Data of Drivers from the api
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // const departmentNameRef = useRef();
  const driverNameRef = useRef();
  const reportingOfficerMobileInputRef = useRef();
  const rpLocationInputRef = useRef();
  const endLocationInputRef = useRef();

  const [filteredCorporates, setIsFilteredCorporates] = useState([]);
  const [filteredDrivers, setIsFilteredDrivers] = useState([]);
  // const [isGetDriverData, setIsGetDriverData] = useState(localStorage.getItem("roleId") === "1" ? false : true);
  const [isGetDriverData, setIsGetDriverData] = useState(true);
  const [isNextClicked, setIsNextClicked] = useState(false);
  const [dateRange, setDateRange] = useState(null); // Only start and end
  const [dateValues, setDateValues] = useState([]);
  const [shiftTimings, setShiftTimings] = useState([]);
  const [isShiftSaveClicked, setIsShiftSaveClicked] = useState(false);
  const [isShiftCreationSuccess, setIsShiftCreationSuccess] = useState(false);
  const [isShiftDataCollected, setIsShiftDataCollected] = useState(false);
  const [formError, setFormError] = useState(errorFileds);
  const shiftStartTimeInputRef = useRef();
  const [storeCorporateIdInEdit, setStoreCorporateIdInEdit] = useState();
  const shiftEndTimeInputRef = useRef();
  const history = useHistory();
  const [shiftData, setShiftData] = useState([]);

  const [time, setTime] = useState({ hours: 0, minutes: 0 });

  const [endLocation, setEndLocation] = useState("");
  const [endLocationError, setEndLocationError] = useState("");
  // const [IsStartShiftOtpEnable, setIsStartShiftOtpEnable] = useState(false);
  const [IsStartShiftOtpEnable, setIsStartShiftOtpEnable] = useState(() => {
    const roleId = localStorage.getItem("roleId");
    return (
      roleId != 1 &&
      localStorage.getItem("shiftStartOTPFromLocalStorage") == "true"
    );
  });

  const [IsEndShiftOtpEnable, setIsEndShiftOtpEnable] = useState(() => {
    const roleId = localStorage.getItem("roleId");
    return (
      roleId != 1 &&
      localStorage.getItem("shiftEndOTPFromLocalStorage") == "true"
    );
  });

  const [tasks, setTasks] = useState([]);
  const [selectedTasks, setSelectedTasks] = useState(null);
  const [parentCorporateId, setParentCorporateId] = useState("");

  const [autocompleteKey, setAutocompleteKey] = useState(0);
  const { isLoading, sendRequest } = useHttp();

  // Add this effect to force remount when tasks/selectedTasks are ready
  useEffect(() => {
    if (tasks && selectedTasks) {
      setAutocompleteKey((prev) => prev + 1);
    }
  }, [tasks, selectedTasks]);

  // Track window width for responsive design
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getSelectedTaskNames = () => {
    if (!selectedTasks || !tasks) return [];

    return selectedTasks
      .toString() // Ensure it's a string
      .split(",")
      .map((id) => id.trim())
      .map((id) => {
        const task = tasks.find((t) => t.taskID.toString() === id);
        if (!task) {
          console.warn(`Task with ID ${id} not found in tasks`);
          return null;
        }
        return task.taskName;
      })
      .filter(Boolean);
  };

  const [selectedDriverEmail, setSelectedDriverEmail] = useState(null);
  const [selectedDrivers, setSelectedDrivers] = useState([]); // Array to store multiple selected drivers
  const [corporateId, setCorporateId] = useState(""); // State to hold CorporateId
  const [departmentId, setDepartmentId] = useState(""); // State to hold CorporateId

  const [parameterJSON, setParameterJSON] = useState(null);
  const [selectDepartment, setSelectDepartment] = useState(null);
  const [selectedDepartmentAfterOption, setSelectedDepartmentAfterOption] =
    useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  shiftId = queryParams.get("shiftId");

  // const handleDepartmentChange=(e)=>{
  //   setSelectDepartment(e.target.value)
  // }

  // Store emailIDs from edit mode to set drivers later when driverDetails is loaded
  const [editModeEmailIDs, setEditModeEmailIDs] = useState(null);

  // This getShiftDetails is coming from the api and it is used to change in the edit-----
  const getShiftDetails = (responseData) => {
    // debugger;
    try {
      let datata = responseData?.shift;
      if (responseData.shift) {
        // Store emailIDs for later processing when driverDetails is loaded
        const emailIDs = datata?.emailID ? datata.emailID.split(",").map(e => e.trim()) : [datata?.emailID].filter(Boolean);
        setEditModeEmailIDs(emailIDs);
        
        // Fallback display for single driver
        driverNameRef.current.value =
          datata.driver?.fName !== null ? datata?.driver?.fName : null;
        setSelectedDriverEmail(datata?.emailID);
        setStoreCorporateIdInEdit(datata?.corporateID);

        startLatLng = ExtractLatLng(
          // datata?.[0]?.ReportingLL
          datata?.startLL
        );
        // setSelectedTasks(datata?.taskIds);

        setSelectedTasks(datata?.taskIds?.trim()?.replace(/\s/g, "") || "");

        // With:
        // const taskIdsArray =
        //   datata?.taskIds?.split(",")?.map((id) => id.trim()) || [];
        // setSelectedTasks(taskIdsArray);
        // endLatLng = ExtractLatLng(responseData?.DriverShiftList[0]?.ShiftEndLL);
        endLatLng = ExtractLatLng(datata?.endLL);

        corporateNameRef.current.value =
          datata?.corporate?.name !== null ? datata?.corporate?.name : "";
        // setCorporateId(datata?.corporate?.parentID); // Set CorporateId state
        setCorporateId(datata?.corporateID);
        // setDepartmentId(datata?.corporateID);
        setDepartmentId(datata?.departmentID);
        setSelectedDepartmentAfterOption(datata?.departmentID);
        setSelectDepartment([
          { corporateID: datata?.departmentID, name: datata?.departmentName },
        ]);

        if (datata?.reportingOfficer?.split("")?.length > 10) {
          reportingOfficerMobileInputRef.current.value =
            datata?.reportingOfficer?.split("").slice(2).join("");
        } else {
          reportingOfficerMobileInputRef.current.value =
            datata?.reportingOfficer;
        }

        rpLocationInputRef.current.value =
          datata?.startLocation !== null ? datata?.startLocation : null;

        endLocationInputRef.current.value =
          datata?.endLocation !== null ? datata?.endLocation : null;

        setIsStartShiftOtpEnable(
          datata?.isStartShiftOtpEnable === 1 ? true : false
        );

        setIsEndShiftOtpEnable(
          datata?.isEndShiftOtpEnable === 1 ? true : false
        );

        if (
          startLatLng &&
          !isNaN(startLatLng.lat) &&
          !isNaN(startLatLng.lng) &&
          startLatLng.lat !== 0 &&
          startLatLng.lng !== 0
        ) {
          map.setCenter(startLatLng);
          map.setZoom(18);
          startLocationMarker.setVisible(true);
          startLocationMarker.setPosition(startLatLng);

          if (
            endLatLng &&
            !isNaN(endLatLng.lat) &&
            !isNaN(endLatLng.lng) &&
            endLatLng.lat !== 0 &&
            endLatLng.lng !== 0
          ) {
            endLocationMarker.setVisible(true);
            endLocationMarker.setPosition(endLatLng);
          } else {
            endLocationMarker.setVisible(false);
          }
        } else {
          startLocationMarker.setVisible(false);
          endLocationMarker.setVisible(false);
        }

        // Extract and format start and end timings

        const shiftTimings = [{}];

        // Parse the original times
        const startDateTime = new Date(datata.startTime);
        const endDateTime = new Date(datata.endTime);

        // Manually subtract 5 hours and 30 minutes (5.5 * 60 * 60 * 1000 milliseconds)
        const offsetMilliseconds = 6.5 * 60 * 60 * 1000;

        const adjustedStartDateTime = new Date(
          startDateTime.getTime() - offsetMilliseconds
        );
        const adjustedEndDateTime = new Date(
          endDateTime.getTime() - offsetMilliseconds
        );

        // Format adjusted dates
        shiftTimings[0].startDate =
          adjustedStartDateTime.toLocaleDateString("en-CA");
        shiftTimings[0].startTime = adjustedStartDateTime.toLocaleTimeString(
          "en-GB",
          {
            hour: "2-digit",
            minute: "2-digit",
          }
        );

        shiftTimings[0].endDate =
          adjustedEndDateTime.toLocaleDateString("en-CA");
        shiftTimings[0].endTime = adjustedEndDateTime.toLocaleTimeString(
          "en-GB",
          {
            hour: "2-digit",
            minute: "2-digit",
          }
        );

        setShiftTimings(shiftTimings);
      }
    } catch (error) {
      console.error(error);
    }
  };
  // ----------------------------------------------------------------------------------------
  useEffect(() => {
    if (shiftId) {
      rpLocationInputRef.current.value = "Location";
      reportingOfficerMobileInputRef.current.value = "00";
      driverNameRef.current.value = "Name";
      corporateNameRef.current.value = "select";
      sendRequest(
        {
          // url: "/api/v1/DriverShift/GetDriverShiftDetails",
          url: "/shift",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              filter: {
                corporateID:
                  localStorage.getItem("roleId") == "1"
                    ? ""
                    : localStorage.getItem("adminDepartmentID"),
              },
              shiftID: shiftId,
            },

            // startDate: "",
            // endDate: "",
            // roleId: ROLEIDFROMLOCALSTORAGE,
          },
        },
        getShiftDetails
      );
    }
  }, []);

  useEffect(() => {
    // if (!isNextClicked) {
    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDHdkmGjsfNqasFs6m9CooShFZsqWHcdUs&callback=initMap&libraries=places&v=weekly";
    script.async = true;

    document.body.appendChild(script);
    // }
  }, [isNextClicked]);

  function initMap() {
    // console.log("init");
    map = new window.google.maps.Map(document.getElementById("shift-map"), {
      center: { lat: 23.0225, lng: 72.5714 },
      zoom: 11,
      disableDefaultUI: true,
      fullscreenControl: true,
      zoomControl: true,
    });
    // background-color: rgb(226, 44, 29);

    startLocationMarker = new window.google.maps.Marker({
      map: map,
      animation: window.google.maps.Animation.DROP,
      icon: svgMarkerForStartLocation,
      // icon: LocationOnIcon,
    });

    endLocationMarker = new window.google.maps.Marker({
      map: map,
      animation: window.google.maps.Animation.DROP,
      icon: svgMarkerForEndLocation,
    });

    let inputs = [
      document.getElementById("pac-input"),
      document.getElementById("end-location-input"),
    ];
    let autocomplete = inputs?.map((input) => {
      return new window.google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: ["in"] },
      });
    });
    autocomplete?.forEach((autocomp, index) => {
      autocomp.bindTo("bounds", map);
      autocomp.addListener("place_changed", function () {
        let place = autocomp.getPlace();
        if (!place.geometry || !place.geometry.location) {
          console.log("Place not found");
          return;
        }
        if (index === 0) {
          startLocationMarker.setPosition(place.geometry.location);
          startLocationMarker?.setVisible(true);
          // startLocationMarker.setIcon(
          //   "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
          // );
        } else {
          endLocationMarker.setPosition(place.geometry.location);
          endLocationMarker?.setVisible(true);
        }
        // debugger;

        // adjust the zoom so that both the start and end point cover---
        if (
          startLocationMarker?.getPosition()?.lat() &&
          endLocationMarker?.getPosition()?.lat()
        ) {
          var bounds = new window.google.maps.LatLngBounds();

          startLatLng = new window.google.maps.LatLng(
            startLocationMarker?.getPosition()?.lat(),
            startLocationMarker?.getPosition()?.lng()
          );
          endLatLng = new window.google.maps.LatLng(
            endLocationMarker?.getPosition()?.lat(),
            endLocationMarker?.getPosition()?.lng()
          );

          bounds.extend(startLatLng);
          bounds.extend(endLatLng);
          map.fitBounds(bounds);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(18);
        }
        // --------------------
      });
    });
  }
  window.initMap = initMap;

  const getCorporateList = (data) => {
    // corporates = data?.CorporateList;
    // corporates = data?.corporates;
    corporates =
      data?.corporates?.filter((item) => item.parentID === null) || [];
  };

  const getDriverList = (data) => {
    setDriverDetails(data?.DriverList);
    // drivers = data.DriverList;
    setIsGetDriverData(false);
  };

  // Effect to set selected drivers in edit mode once driverDetails is loaded
  useEffect(() => {
    if (editModeEmailIDs && driverDetails && driverDetails.length > 0) {
      const drivers = editModeEmailIDs
        .map(email => {
          const driver = driverDetails.find(d => d.emailID === email);
          return driver ? {
            name: `${driver.fName} ${driver.lName}`,
            email: driver.emailID
          } : null;
        })
        .filter(Boolean);
      
      if (drivers.length > 0) {
        setSelectedDrivers(drivers);
        driverNameRef.current.value = drivers.map(d => d.name).join(", ");
      }
      setEditModeEmailIDs(null); // Clear after processing
    }
  }, [driverDetails, editModeEmailIDs]);

  const shiftCreationResponse = (data) => {
    // Check if the response is a string (i.e., error message)
    if (typeof data === "string") {
      // Handle string error (likely a validation error)
      setIsShiftCreationSuccess("error"); // Set your state to indicate an error
    } else if (data.status >= 400) {
      // If status code is 400 or above, treat it as an error
      setIsShiftCreationSuccess("error"); // Set your state to indicate an error
    } else {
      // Otherwise, assume the response is successful
      setIsShiftCreationSuccess("success");
    }

    setIsShiftSaveClicked(false); // Reset the save state
  };

  useEffect(() => {
    if (isGetDriverData) {
      sendRequest(
        {
          // url: "/api/v1/DriverList/GetDriverList",
          url: "/corporatedrivers",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              filter: {
                corporateID:
                  localStorage.getItem("roleId") != "1"
                    ? localStorage.getItem("corpId")
                    : "",
              },
            },
            // roleID: localStorage.getItem("roleId"),
          },
        },
        getDriverList
      );
    }
    if (isShiftSaveClicked) {
      let detailsRecord = [];
      if (shiftTimings.length === 0) {
        setFormError((prev) => ({
          ...prev,
          shiftTimingsError: "Please select atleast one shift timing",
        }));
        return;
      }
      for (let i = 0; i < shiftTimings?.length; i++) {
        detailsRecord.push({
          StartTime:
            shiftTimings[i]?.startDate + " " + shiftTimings[i]?.startTime,
          EndTime: shiftTimings[i]?.endDate + " " + shiftTimings[i]?.endTime,
        });
      }

      // console.log("check", startLocationMarker?.getPosition()?.lat());
      sendRequest(
        {
          // url: "/api/v1/DriverShift/AddEditDriverShift",
          url: "/createupdateshift",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              departmentID: selectedDepartmentAfterOption
                ? selectedDepartmentAfterOption
                : // : selectedDepartment.dptId
                // ? selectedDepartment.dptId
                corporateId
                ? corporateId
                : localStorage.getItem("adminDepartmentID"),
              // corporateID: corporateId,
              corporateID: corporateId
                ? corporateId
                : parentCorporateId
                ? parentCorporateId
                : localStorage.getItem("corpId"),
              // parentCorporateID: parentCorporateId
              //   ? parentCorporateId
              //   : CORPORATEIDFROMLOCALSTORAGE,
              // parentCorporateID: corporateId
              //   ? corporateId
              //   : parentCorporateId
              //   ? parentCorporateId
              //   : CORPORATEIDFROMLOCALSTORAGE,
              detailsRecord: JSON.stringify(detailsRecord),
              // driverEmailID: selectedDriver.email,
              // driverEmailID:
              // Support multiple drivers - send as array of emailIDs
              emailID: selectedDrivers.length > 0
                ? selectedDrivers.map(d => d.email).join(",")
                : selectedDriverEmail,

              reportingOfficer:
                "91" + reportingOfficerMobileInputRef.current.value,
              startLL:
                (startLocationMarker?.getPosition()?.lat() ||
                  startLatLng?.lat) &&
                (startLatLng?.lng || startLocationMarker?.getPosition()?.lng())
                  ? (startLocationMarker?.getPosition()?.lat()
                      ? startLocationMarker?.getPosition()?.lat()
                      : startLatLng?.lat) +
                    "," +
                    (startLocationMarker?.getPosition()?.lng()
                      ? startLocationMarker?.getPosition()?.lng()
                      : startLatLng?.lng)
                  : "",

              // ShiftEndLL:
              endLL:
                (endLocationMarker?.getPosition()?.lat() || endLatLng?.lat) &&
                (endLatLng?.lng || endLocationMarker?.getPosition()?.lng())
                  ? (endLocationMarker?.getPosition()?.lat()
                      ? endLocationMarker?.getPosition()?.lat()
                      : endLatLng?.lat) +
                    "," +
                    (endLocationMarker?.getPosition()?.lng()
                      ? endLocationMarker?.getPosition()?.lng()
                      : endLatLng?.lng)
                  : "",
              isStartOtpEnable: IsStartShiftOtpEnable === true,
              isEndOtpEnable: IsEndShiftOtpEnable === true,
              taskIds: selectedTasks,
              // reportingLocaiton: rpLocationInputRef.current.value,
              startLocation: rpLocationInputRef.current.value,
              // shiftEndLocation: endLocationInputRef.current.value,
              endLocation: endLocationInputRef.current.value,
              createdOn: new Date(),
              createdBy: localStorage.getItem("user") || "",

              shiftID: shiftId ? shiftId : "",
            },
          },
        },

        shiftCreationResponse
      );
    }
  }, [isGetDriverData, isShiftSaveClicked]);

  useEffect(() => {
    if (localStorage.getItem("roleId") === "1") {
      sendRequest(
        {
          // url: "/api/v1/Corporate/GetAllDepartmentByCorporate",
          url: "/corporates",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
          },
        },
        getCorporateList
      );
    } else {
      const cpName = localStorage.getItem("cpName");
      const cpId = localStorage.getItem("corpId"); // Assuming corpId is stored in localStorage

      corporateNameRef.current.value = cpName;
      corporateNameRef.current.disabled = true;

      if (cpId) {
        fetchDepartments(cpId);
      }
      // departmentNameRef.current.disabled = true;
    }
    // departmentNameRef.current.value = "Admin Department";
  }, []);

  const fetchDepartments = (corporateID) => {
    sendRequest(
      {
        url: "/departments", // Update with your actual endpoint
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          corporateID: corporateID,
          emailID: localStorage.getItem("user"),
        },
      },
      (data) => {
        setSelectDepartment(
          data?.DepartMentList?.filter((el) => el.parentID == corporateID) || []
        );
      },
      (error) => {
        console.error("Error fetching departments:", error);
        setSelectDepartment([]);
      }
    );
  };

  const driverSearchHandler = (e) => {
    if (e.target.value)
      setIsFilteredDrivers(
        driverDetails?.filter(
          (data) =>
            data?.fName
              ?.toLowerCase()
              .includes(e.target.value?.toLowerCase()) ||
            data.vehicleModal
              ?.toLowerCase()
              .includes(e.target.value?.toLowerCase())
        )
      );
    else setIsFilteredDrivers([]);
  };

  const corporateSearchHandler = (e) => {
    if (e.target.value)
      setIsFilteredCorporates(
        corporates?.filter((data) =>
          data.name.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
    // setParameterJSON(corporates?.filter((data)=>data.))
    else setIsFilteredCorporates([]);
  };

  useEffect(() => {
    sendRequest(
      {
        // url: "/api/v1/ShiftTask/GetShiftTask",
        url: "/tasks",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          data: {
            filter: {
              storeCorporateIdInEdit,
            },
          },
          // departmentID,
          // roleID,
          // taskID: "",
        },
      },
      (data) => {
        setTasks(data?.tasks); // Update tasks state with fetched data
      },
      (error) => {
        console.error("Error fetching tasks:", error);
      }
    );
  }, [storeCorporateIdInEdit]);

  const corporateSelectHandler = async (
    cpName,
    dptNames,
    dptIds,
    cpId,
    parameterjson,
    departments
  ) => {
    setParentCorporateId(cpId);
    setSelectDepartment(departments);

    shiftStartOtpFromConfig = parameterjson
      ? JSON.parse(parameterjson)?.shiftStartOTP
      : false;
    shiftEndOtpFromConfig = parameterjson
      ? JSON.parse(parameterjson)?.shiftEndOTP
      : false;

    setIsStartShiftOtpEnable(shiftStartOtpFromConfig || false);
    setIsEndShiftOtpEnable(shiftEndOtpFromConfig || false);

    corporateNameRef.current.value = cpName;

    // Check if dptNames and dptIds have valid values before manipulating them
    if (dptNames && dptIds) {
      let departments = dptNames.toLowerCase().split(",");
      let ids = dptIds.split(",");

      // Set the first department and ID as the default
      selectedDepartment.name = departments[0].trim(); // Trim to remove any extra spaces
      selectedDepartment.dptId = ids[0].trim();
    } else {
      console.warn("dptNames or dptIds is null or undefined.");
    }

    // Reset the selected tasks when corporate is changed
    setSelectedTasks(null);
    setTasks([]); // Reset the task list
    setFormError((prev) => ({ ...prev, coprorateNameError: "" }));
    // departmentNameRef.current.value = selectedDepartment.name;
    setIsFilteredCorporates([]);

    const roleID = localStorage.getItem("roleId");

    // Call API only if roleId is 1 (Admin)
    if (roleID === "1") {
      const emailID = localStorage.getItem("user");
      const corporateID = cpId; // Use selected corporate ID
      const departmentID = selectedDepartment.dptId;

      try {
        sendRequest(
          {
            // url: "/api/v1/ShiftTask/GetShiftTask",
            url: "/tasks",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: {
              emailID,
              data: {
                filter: {
                  corporateID,
                },
              },
              // departmentID,
              // roleID,
              // taskID: "",
            },
          },
          (data) => {
            setTasks(data?.tasks); // Update tasks state with fetched data
          },
          (error) => {
            console.error("Error fetching tasks:", error);
          }
        );
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    }
  };

  // API call for roleId == 2 (Non-Admin) on page load
  useEffect(() => {
    const roleID = localStorage.getItem("roleId");

    if (roleID == "2") {
      const emailID = localStorage.getItem("user");
      const corporateID = localStorage.getItem("corpId"); // Use corporate ID from localStorage
      const departmentID = "";

      try {
        sendRequest(
          {
            // url: "/api/v1/ShiftTask/GetShiftTask",
            url: "/tasks",

            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: {
              emailID,
              // corporateID,
              // departmentID,
              // roleID,
              // taskID: "",
              emailID: emailID,
              data: {
                filter: {
                  corporateID: corporateID,
                },
              },
            },
          },
          (data) => {
            setTasks(data?.tasks); // Update tasks state with fetched data
          },
          (error) => {
            console.error("Error fetching tasks:", error);
          }
        );
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    }
  }, []); // Call only once when the page is loaded

  const driverSelectHandler = (drName, drEmail) => {
    // This handler is kept for backward compatibility but may not be used with Autocomplete
    const driver = { name: drName, email: drEmail };
    if (!selectedDrivers.find(d => d.email === drEmail)) {
      setSelectedDrivers([...selectedDrivers, driver]);
    }
    setFormError((prev) => ({ ...prev, driverNameError: "" }));
    setIsFilteredDrivers([]);
  };

  // Handler for multiple driver selection with Autocomplete
  const handleDriverChange = (event, newValue) => {
    if (!newValue || newValue.length === 0) {
      setSelectedDrivers([]);
    } else {
      // newValue is an array of driver names
      const drivers = newValue.map(driverName => {
        const driver = driverDetails.find(d => 
          `${d?.fName} ${d?.lName} (${d?.vehicleModal})` === driverName
        );
        return driver ? { name: `${driver.fName} ${driver.lName}`, email: driver.emailID } : null;
      }).filter(Boolean);
      setSelectedDrivers(drivers);
    }
    setFormError((prev) => ({ ...prev, driverNameError: "" }));
  };

  // Get selected driver names for Autocomplete display - memoized to prevent unnecessary re-renders
  const selectedDriverNames = useMemo(() => {
    if (!driverDetails || driverDetails.length === 0 || selectedDrivers.length === 0) {
      return [];
    }
    return selectedDrivers.map(driver => {
      // Find the full driver details to match the option format
      const fullDriver = driverDetails.find(d => d.emailID === driver.email);
      if (fullDriver) {
        return `${fullDriver.fName} ${fullDriver.lName} (${fullDriver.vehicleModal})`;
      }
      return null; // Return null for unmatched drivers
    }).filter(Boolean); // Filter out null values
  }, [selectedDrivers, driverDetails]);

  
  const startTimePickerCloseHandler = () => {
    if (!dateValues?.length) return;

    const updatedShiftData = [];

    for (let i = 0; i < dateValues.length; i++) {
      updatedShiftData[i] = {
        startDate: new Date(dateValues[i]).toISOString().slice(0, 10),
        startTime: shiftStartTimeInputRef?.current?.value,
        endDate: new Date(dateValues[i]).toISOString().slice(0, 10),
      };
    }

    // Store or use updatedShiftData here
    setShiftData(updatedShiftData);
    const startTimeForTotalMinutes = shiftStartTimeInputRef?.current?.value;
    const endTimeForTotalMinutes = shiftEndTimeInputRef?.current?.value;

    calculateTotalTime(startTimeForTotalMinutes, endTimeForTotalMinutes);
  };

  //   End Time
  // const endTimePickerCloseHandler = (e) => {
  //   for (let i = 0; i < dateValues?.length; i++) {
  //     shiftData[i].endTime = shiftEndTimeInputRef?.current?.value;
  //   }
  //   const startTimeForTotalMinutes = shiftStartTimeInputRef?.current?.value;
  //   const endTimeForTotalMinutes = shiftEndTimeInputRef?.current?.value;
  //   calculateTotalTime(startTimeForTotalMinutes, endTimeForTotalMinutes);
  // };
  const endTimePickerCloseHandler = () => {
    if (!dateValues?.length) return;

    const updatedShiftData = [];

    for (let i = 0; i < dateValues.length; i++) {
      const date = new Date(dateValues[i]);
      const formattedDate = date.toISOString().slice(0, 10);

      updatedShiftData[i] = {
        startDate: formattedDate,
        endDate: formattedDate,
        startTime: shiftStartTimeInputRef?.current?.value || "", // fallback if empty
        endTime: shiftEndTimeInputRef?.current?.value || "",
      };
    }

    // Store or use updatedShiftData
    setShiftData(updatedShiftData);
    const startTimeForTotalMinutes = shiftStartTimeInputRef?.current?.value;
    const endTimeForTotalMinutes = shiftEndTimeInputRef?.current?.value;
    calculateTotalTime(startTimeForTotalMinutes, endTimeForTotalMinutes);
  };

  // Calculated total time ---------------
  const calculateTotalTime = (startTime, endTime) => {
    if (startTime && endTime) {
      const [startHour, startMinute] = startTime.split(":").map(Number);
      const [endHour, endMinute] = endTime.split(":").map(Number);

      let totalMinutes =
        endHour * 60 + endMinute - (startHour * 60 + startMinute);

      // If end time is before start time, add 24 hours
      if (totalMinutes < 0) {
        totalMinutes += 24 * 60;
      }

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      setTime({ hours, minutes });
    }
  };

  const shiftRowCancelHandler = (i) => {
    shiftData?.filter((val, index) => index !== i);
    setShiftTimings((prev) => prev?.filter((val, index) => index !== i));
    setDateValues((prev) => prev?.filter((val, index) => index !== i));
  };

  const shiftRowValueChangeHandler = (e, i) => {
    // debugger;
    let a = structuredClone(shiftTimings);
    a[i][e.target.name] = e.target.value;
    // console.log(a);
    setShiftTimings(a);
    shiftData = a;
    // console.log(e.targetIndex);
  };

  const addShiftDetailsClickHandler = () => {
    if (
      !shiftStartTimeInputRef.current.value ||
      !shiftEndTimeInputRef.current.value
    ) {
      setFormError((prev) => ({
        ...prev,
        shiftTimingsError: "Please select both start and end times",
      }));
      return;
    }

    if (dateValues.length === 0) {
      setFormError((prev) => ({
        ...prev,
        shiftTimingsError: "Please select a date range",
      }));
      return;
    }

    const startTime = shiftStartTimeInputRef.current.value;
    const endTime = shiftEndTimeInputRef.current.value;

    // Check if start time is less than end time
    const startTimeLessThanEndTime = startTime < endTime;

    // let newShiftTimings = [];

    // for (let i = 0; i < dateValues.length; i++) {
    //   const date = new Date(dateValues[i]);
      
    //   const formattedDate = date.toISOString().slice(0, 10);

    //   newShiftTimings.push({
    //     startDate: formattedDate,
    //     startTime: startTime,
    //     endDate: startTimeLessThanEndTime
    //       ? formattedDate
    //       : // If end time is before start time, use next day
    //         new Date(date.setDate(date.getDate() + 1))
    //           .toISOString()
    //           .slice(0, 10),
    //     endTime: endTime,
    //   });
    // }


    let newShiftTimings = [];

    for (let i = 0; i < dateValues.length; i++) {
      const date = new Date(dateValues[i]);
      // Normalize to local midnight to avoid timezone issues
      date.setHours(0, 0, 0, 0);
      
      // Format date as YYYY-MM-DD using local date methods
      const formattedDate = date.toLocaleDateString('en-CA'); // 'en-CA' gives YYYY-MM-DD format

      // Create a copy for end date calculation
      const endDate = new Date(date);
      
      newShiftTimings.push({
        startDate: formattedDate,
        startTime: startTime,
        endDate: startTimeLessThanEndTime
          ? formattedDate
          : (() => {
              // If end time is before start time, use next day
              endDate.setDate(endDate.getDate() + 1);
              return endDate.toLocaleDateString('en-CA');
            })(),
        endTime: endTime,
      });
    }
    setFormError((prev) => ({ ...prev, shiftTimingsError: "" }));
    setShiftTimings([...shiftTimings, ...newShiftTimings]);

    // Reset inputs
    shiftStartTimeInputRef.current.value = "";
    shiftEndTimeInputRef.current.value = "";
    setDateValues([]);
  };

  const corporateNameChangeHandler = () => {
    if (corporateNameRef.current.value) {
      setFormError((prev) => ({ ...prev, coprorateNameError: "" }));
    }
  };

  const roMobileNumberChangeHandler = () => {
    if (reportingOfficerMobileInputRef.current.value) {
      setFormError((prev) => ({ ...prev, roMobileError: "" }));
    }
  };

  const rpLocationChangeHandler = () => {
    if (rpLocationInputRef.current.value) {
      setFormError((prev) => ({ ...prev, rpLocationError: "" }));
    }
  };
  // Handler function for end location change
  const endLocationChangeHandler = () => {
    if (endLocationInputRef.current.value) {
      setFormError((prev) => ({ ...prev, endLocationError: "" }));
    }
  };

  const nextSlideClickHandler = (isNextClicked) => {
    // debugger;
    if (isNextClicked) {
      setTimeout(() => {
        // if (marker?.getPosition()?.lat())
        //     startLatLng.lat = marker.getPosition().lat();
        // if (marker?.getPosition()?.lng())
        //     startLatLng.lng = marker.getPosition().lng();
        map.setCenter(
          shiftId
            ? { lat: startLatLng?.lat, lng: startLatLng?.lng }
            : {
                lat: marker?.getPosition()?.lat(),
                lng: marker?.getPosition()?.lng(),
              }
        );
        map?.setZoom(18);
        marker?.setVisible(true);
        marker?.setPosition(
          shiftId
            ? { lat: startLatLng.lat, lng: startLatLng.lng }
            : {
                lat: marker?.getPosition()?.lat(),
                lng: marker?.getPosition()?.lng(),
              }
        );
      }, 1000);
    }
    if (!corporateNameRef.current.value) {
      setFormError((prev) => ({
        ...prev,
        coprorateNameError: "Invalid Corporate Name",
      }));
    }
    // if (!departmentNameRef.current.value) {
    //   setFormError((prev) => ({
    //     ...prev,
    //     departmentNameError: "Invalid Department Name",
    //   }));
    // }
    if (
      !reportingOfficerMobileInputRef.current.value ||
      reportingOfficerMobileInputRef.current.value?.length !== 10
    ) {
      setFormError((prev) => ({
        ...prev,
        roMobileError: "Invalid Mobile Number",
      }));
    }
    if (!rpLocationInputRef.current.value) {
      setFormError((prev) => ({
        ...prev,
        rpLocationError: "Invalid Reporting Location",
      }));
    }
    if (selectedDrivers.length === 0) {
      setFormError((prev) => ({
        ...prev,
        driverNameError: "Please select at least one driver",
      }));
    }
    if (
      corporateNameRef.current.value &&
      // departmentNameRef.current.value &&
      reportingOfficerMobileInputRef?.current?.value?.length === 10 &&
      // rpLocationInputRef.current.value &&
      selectedDrivers.length > 0
    ) {
      setIsNextClicked((prev) => !prev);
    }
  };

  const handleTaskChange = (event, newValue) => {
    if (!newValue || newValue.length === 0) {
      setSelectedTasks(null);
    } else {
      const selectedTaskIds = newValue
        ?.map((taskName) => getTaskIdFromName(taskName))
        .filter(Boolean)
        .join(",");
      setSelectedTasks(selectedTaskIds);
    }
  };
  // Function to get TaskID from selected TaskName
  const getTaskIdFromName = (taskName) => {
    const selectedTask = tasks?.find((task) => task.taskName === taskName);
    return selectedTask ? selectedTask.taskID : null;
  };

  const getAllDatesInRange = (start, end) => {
    const dates = [];
    const current = new Date(start);
    while (current <= end) {
      dates.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  return (
    <div
      className="shift-creation-page"
      style={{
        width: "100%",
        height: "100%",
        // margin: "8px 8px 8px 8px",
        boxSizing: "border-box",
      }}
    >
      <div className="shift-container">
        <div className="shift-general-details">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              // padding: "16px 16px 12px 16px",
              maxHeight: "calc(100vh - 200px)",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {/* Form header inside the card */}
            <div
              style={{
                textTransform: "uppercase",
                fontWeight: "bold",
                fontSize: "18px",
                marginBottom: "8px",
              }}
            >
              Shift Creation
            </div>
            <div style={{ position: "relative" }}>
              <TextField
                className="standard-basic"
                error={formError.coprorateNameError ? true : false}
                helperText={formError.coprorateNameError}
                label="Corporate"
                variant="standard"
                inputRef={corporateNameRef}
                onChange={corporateSearchHandler}
                autoComplete="off"
              />
              {filteredCorporates && (
                <>
                  <div className="searchedDriverList">
                    {filteredCorporates?.map((cp) => (
                      <p
                        onClick={() =>
                          corporateSelectHandler(
                            cp.name,
                            cp.DepartmentName,
                            cp.DepartmentID,
                            cp.corporateID,
                            cp.parameterJSON,
                            cp.departments
                          )
                        }
                      >
                        {cp.name}
                      </p>
                    ))}
                  </div>
                </>
              )}
            </div>

            <FormControl fullWidth>
              <InputLabel
                sx={{ left: "-13px", top: "8px" }}
                // id="demo-simple-select-label"
              >
                Department
              </InputLabel>
              <Select
                // labelId="demo-simple-select-label"
                // id="demo-simple-select"
                variant="standard"
                // value={age}
                value={selectedDepartmentAfterOption ?? ""}
                label="Department"
                onChange={(e) =>
                  setSelectedDepartmentAfterOption(e.target.value)
                }
              >
                <MenuItem value="">Select Department</MenuItem>
                {selectDepartment?.map((dept) => (
                  <MenuItem key={dept?.corporateID} value={dept?.corporateID}>
                    {dept?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div style={{ position: "relative" }}>
              <Autocomplete
                multiple
                options={driverDetails.map((dr) => 
                  `${dr?.fName} ${dr?.lName} (${dr?.vehicleModal})`
                )}
                value={selectedDriverNames}
                isOptionEqualToValue={(option, value) => option === value}
                onChange={handleDriverChange}
                renderTags={(value, getTagProps) => {
                  const numTags = value.length;
                  const limitTags = 1;
                  
                  // Extract first name from the full driver string (format: "FirstName LastName (Vehicle)")
                  const getFirstName = (fullName) => {
                    const match = fullName.match(/^(\w+)/);
                    return match ? match[1] : fullName;
                  };
                  
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "nowrap",
                        alignItems: "center",
                        gap: "4px",
                        maxWidth: "100%",
                        overflow: "hidden",
                      }}
                    >
                      {value.slice(0, limitTags).map((option, index) => (
                        <Chip
                          {...getTagProps({ index })}
                          key={index}
                          label={getFirstName(option)}
                          size="small"
                          sx={{
                            height: "24px",
                            fontSize: "0.75rem",
                            margin: "0 2px",
                            maxWidth: "120px",
                            "& .MuiChip-label": {
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              padding: "0 8px",
                            },
                          }}
                        />
                      ))}
                      {numTags > limitTags && (
                        <Chip
                          label={`+${numTags - limitTags} more`}
                          size="small"
                          sx={{
                            height: "24px",
                            fontSize: "0.75rem",
                            margin: "0 2px",
                            backgroundColor: "rgba(34, 137, 203, 0.1)",
                            color: "rgba(34, 137, 203, 1)",
                            fontWeight: "500",
                            flexShrink: 0,
                            "& .MuiChip-label": {
                              padding: "0 8px",
                            },
                          }}
                        />
                      )}
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="standard-basic"
                    error={formError.driverNameError ? true : false}
                    helperText={formError.driverNameError}
                    label="Driver Details"
                    variant="standard"
                    autoComplete="off"
                  />
                )}
                sx={{
                  "& .MuiAutocomplete-tag": {
                    margin: "0",
                  },
                  "& .MuiAutocomplete-inputRoot": {
                    flexWrap: "nowrap",
                    minHeight: "40px",
                    alignItems: "center",
                    padding: "4px 0 !important",
                  },
                  "& .MuiAutocomplete-input": {
                    minWidth: "50px !important",
                    flex: "1 1 auto",
                  },
                }}
              />
            </div>
            <TextField
              className="standard-basic"
              onChange={roMobileNumberChangeHandler}
              error={formError?.roMobileError ? true : false}
              type="number"
              inputProps={{ maxLength: 10 }}
              helperText={formError?.roMobileError}
              label="Reporting Officer Mobile Number"
              variant="standard"
              inputRef={reportingOfficerMobileInputRef}
              autoComplete="off"
              style={{ marginTop: "8px" }}
            />
            {/* Reporting Location + Enable checkbox - stacked vertically */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "0",
                
              }}
            >
              <TextField
                className="standard-basic"
                onChange={rpLocationChangeHandler}
                // error={formError.rpLocationError ? true : false}
                // helperText={formError.rpLocationError}
                label="Reporting Location"
                id="pac-input"
                variant="standard"
                inputRef={rpLocationInputRef}
                autoComplete="off"
                style={{ width: "100%" }}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    name="reportingLocation"
                    sx={{
                      "& .MuiSvgIcon-root": { fontSize: 18, color: "#ccc" },
                    }}
                    checked={IsStartShiftOtpEnable}
                    onChange={() =>
                      setIsStartShiftOtpEnable(!IsStartShiftOtpEnable)
                    }
                  />
                }
                style={{
                  marginTop: "8px",
                  marginLeft: "0",
                }}
                label={
                  <span style={{ color: "gray", opacity: "0.75" }}>
                    Enable Report Location
                  </span>
                }
              />
            </div>

            {/* End Location + Enable checkbox - stacked vertically */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "0",
                marginTop: "-16px",
              }}
            >
              <TextField
                className="standard-basic"
                onChange={endLocationChangeHandler}
                error={endLocationError ? true : false}
                helperText={endLocationError}
                inputRef={endLocationInputRef}
                label="End Location"
                variant="standard"
                id="end-location-input"
                autoComplete="off"
                style={{ flex: 1 }}
              />

              <FormControlLabel
                control={
                  <Checkbox
                    name="endLocationEnabled"
                    sx={{
                      "& .MuiSvgIcon-root": { fontSize: 18, color: "#ccc" },
                    }}
                    checked={IsEndShiftOtpEnable}
                    onChange={() =>
                      setIsEndShiftOtpEnable(!IsEndShiftOtpEnable)
                    }
                  />
                }
                style={{
                  marginTop: "8px",
                  marginLeft: "0",
                  whiteSpace: "nowrap",
                }}
                label={
                  <span style={{ color: "gray", opacity: "0.75" }}>
                    Enable End Location
                  </span>
                }
              />
            </div>

            {!tasks ? (
              <CircularProgress />
            ) : (
              <Autocomplete
                key={autocompleteKey}
                style={{ marginTop: "-16px" }}
                multiple
                options={tasks.map((task) => task.taskName)}
                value={getSelectedTaskNames()}
                isOptionEqualToValue={(option, value) => option === value}
                onChange={(event, newValue) => {
                  const selectedIds = newValue
                    .map(
                      (name) =>
                        tasks.find((task) => task.taskName === name)?.taskID
                    )
                    .filter(Boolean)
                    .join(",");
                  setSelectedTasks(selectedIds || ""); // Ensure we never set null
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Task Name" variant="standard" />
                )}
              />
            )}
          </div>
          {isNextClicked && (
            <div
              style={{
                position: "absolute",
                backgroundColor: "whitesmoke",
                top: "0",
                left: "0",
                width: "100%",
                height: "80%",
                opacity: "0.3",
                cursor: "not-allowed",
              }}
            ></div>
          )}
          <div style={{ alignSelf: "flex-end", marginTop: "30px" }}>
            <button
              id="shiftNext"
              style={{
                backgroundColor: "rgba(34, 137, 203, 255)",
                width: "80px",
                color: "white",
                border: "1px solid rgba(34, 137, 203, 255)",
                padding: "7px 15px",
                borderRadius: "10px",
                cursor: "pointer",
              }}
              onClick={() => nextSlideClickHandler(isNextClicked)}
            >
              {isNextClicked ? "BACK" : "NEXT"}
            </button>
          </div>
        </div>
        <div className="shift-timing-details">
          {!isNextClicked ? (
            <div style={{ height: "300px" }}>
              {" "}
              {/* Fixed height for mobile */}
              <ShiftMap />
            </div>
          ) : (
            <div
              style={{
                backgroundColor: "#f3f6f9",
                width: "100%",
                height: "100%",
                padding: "10px",
                overflowX: "auto",
              }}
            >
              <div
                // style={{
                //   display: "flex",
                //   justifyContent: "space-between",
                //   margin: "0 2%",
                // }}

                style={{
                  display: windowWidth <= 768 ? "block" : "flex",
                  flexDirection: windowWidth <= 768 ? "column" : "row",
                  alignItems:
                    windowWidth <= 768 ? "stretch" : "center",
                  justifyContent: windowWidth <= 768 ? "flex-start" : "space-between",
                  gap: windowWidth <= 768 ? "15px" : "10px",
                  margin: windowWidth <= 768 ? "0" : "0 2%",
                  padding: windowWidth <= 768 ? "10px" : "10px 0",
                  overflowX: windowWidth <= 768 ? "visible" : "auto",
                  whiteSpace: windowWidth <= 768 ? "normal" : "nowrap",
                }}
              >
                <div
                  style={{
                    display: windowWidth <= 768 ? "block" : "flex",
                    flexDirection: windowWidth <= 768 ? "column" : "row",
                    alignItems: windowWidth <= 768 ? "stretch" : "baseline",
                    minWidth: windowWidth <= 768 ? "100%" : "200px",
                    width: windowWidth <= 768 ? "100%" : "auto",
                    gap: windowWidth <= 768 ? "10px" : "0",
                  }}
                >
                  <label
                    htmlFor="date"
                    style={{
                      fontSize: "12px",
                      minWidth: windowWidth <= 768 ? "100%" : "50px",
                      marginBottom: windowWidth <= 768 ? "5px" : "0",
                      display: "block",
                    }}
                  >
                    Date:
                  </label>

                  <div style={{
                    width: windowWidth <= 768 ? "100%" : "auto",
                    minWidth: windowWidth <= 768 ? "100%" : "auto"
                  }}>
                    <CustomCalender
                      onDateRangeChange={(range, allDates) => {
                        setDateRange(range);

                        setDateValues(allDates);
                      }}
                      allowDates="future"
                      // shortcuts={[
                      //   {
                      //     name: "Today",
                      //     range: () => {
                      //       const today = new Date();
                      //       today.setHours(0, 0, 0, 0);
                      //       return [today, today];
                      //     },
                      //   },
                      //   {
                      //     name: "Next 15 Days",
                      //     range: () => {
                      //       const today = new Date();
                      //       const end = new Date();
                      //       end.setDate(today.getDate() + 14);
                      //       return [today, end];
                      //     },
                      //   },
                      //   {
                      //     name: "Current Month",
                      //     range: () => {
                      //       const today = new Date();
                      //       const end = new Date(
                      //         today.getFullYear(),
                      //         today.getMonth() + 1,
                      //         0
                      //       );
                      //       return [today, end];
                      //     },
                      //   },
                      // ]}

                      shortcuts={[
                        {
                          name: "Today",
                          range: () => {
                            const today = new Date();
                            // Normalize to midnight to avoid timezone/time issues
                            today.setHours(0, 0, 0, 0);
                            return [today, today];
                          },
                        },
                        {
                          name: "Next 15 Days",
                          range: () => {
                            const today = new Date();
                            today.setHours(0, 0, 0, 0); // Normalize to midnight
                            const end = new Date();
                            end.setHours(0, 0, 0, 0); // Normalize to midnight
                            end.setDate(today.getDate() + 14);
                            return [today, end];
                          },
                        },
                        {
                          name: "Current Month",
                          range: () => {
                            const today = new Date();
                            today.setHours(0, 0, 0, 0); // Normalize to midnight
                            const end = new Date(
                              today.getFullYear(),
                              today.getMonth() + 1,
                              0
                            );
                            end.setHours(0, 0, 0, 0); // Normalize to midnight
                            return [today, end];
                          },
                        },
                      ]}
                    />
                  </div>
                  <div
                    style={{
                      display: windowWidth <= 768 ? "block" : "flex",
                      flexDirection: windowWidth <= 768 ? "column" : "row",
                      alignItems: windowWidth <= 768 ? "stretch" : "baseline",
                      minWidth: windowWidth <= 768 ? "100%" : "180px",
                      width: windowWidth <= 768 ? "100%" : "auto",
                      marginTop: windowWidth <= 768 ? "0" : "0",
                    }}
                  >
                    <label 
                      htmlFor="startTime" 
                      style={{ 
                        fontSize: "14px",
                        marginBottom: windowWidth <= 768 ? "5px" : "0",
                        display: "block"
                      }}
                    >
                      Start Time:
                    </label>
                    <input
                      className="jay"
                      style={{
                        border: windowWidth <= 768 ? "1px solid #ddd" : "none",
                        height: windowWidth <= 768 ? "auto" : "20px",
                        padding: windowWidth <= 768 ? "8px" : "0 0 0 7px",
                        borderRadius: "5px",
                        width: windowWidth <= 768 ? "100%" : "85px",
                        boxSizing: "border-box",
                      }}
                      type="text"
                      placeholder="Start Time"
                      onChange={startTimePickerCloseHandler}
                      ref={shiftStartTimeInputRef}
                      onFocus={(e) => (e.target.type = "time")}
                      onBlur={(e) => (e.target.type = "text")}
                    />
                  </div>
                  <div
                    style={{
                      display: windowWidth <= 768 ? "block" : "flex",
                      flexDirection: windowWidth <= 768 ? "column" : "row",
                      alignItems: windowWidth <= 768 ? "stretch" : "baseline",
                      minWidth: windowWidth <= 768 ? "100%" : "180px",
                      width: windowWidth <= 768 ? "100%" : "auto",
                      marginTop: windowWidth <= 768 ? "0" : "0",
                    }}
                  >
                    <label 
                      htmlFor="endTIme" 
                      style={{ 
                        fontSize: "14px",
                        marginBottom: windowWidth <= 768 ? "5px" : "0",
                        display: "block"
                      }}
                    >
                      End Time:
                    </label>
                    <input
                      className="jay"
                      style={{
                        border: windowWidth <= 768 ? "1px solid #ddd" : "none",
                        height: windowWidth <= 768 ? "auto" : "20px",
                        padding: windowWidth <= 768 ? "8px" : "0 0 0 7px",
                        borderRadius: "5px",
                        width: windowWidth <= 768 ? "100%" : "85px",
                        boxSizing: "border-box",
                      }}
                      type="text"
                      placeholder="End Time"
                      onChange={endTimePickerCloseHandler}
                      ref={shiftEndTimeInputRef}
                      onFocus={(e) => (e.target.type = "time")}
                      onBlur={(e) => (e.target.type = "text")}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: windowWidth <= 768 ? "block" : "flex",
                    alignItems: "center",
                    minWidth: windowWidth <= 768 ? "100%" : "150px",
                    width: windowWidth <= 768 ? "100%" : "auto",
                    marginTop: windowWidth <= 768 ? "0" : "0",
                  }}
                >
                  <p style={{ fontSize: "14px", margin: 0 }}>
                    Total Time: {time?.hours} Hr {time?.minutes} Min
                  </p>
                </div>
                <button
                  className="addShiftDetails"
                  onClick={addShiftDetailsClickHandler}
                  style={{
                    minWidth: windowWidth <= 768 ? "100%" : "120px",
                    width: windowWidth <= 768 ? "100%" : "auto",
                    marginLeft: windowWidth <= 768 ? "0" : "10px",
                    marginTop: windowWidth <= 768 ? "0" : "0",
                    padding: windowWidth <= 768 ? "10px" : "5px 10px",
                  }}
                >
                  Add Details
                </button>
              </div>
              <div
                style={{
                  background: "white",
                  height: windowWidth <= 768 ? "auto" : "90%",
                  minHeight: windowWidth <= 768 ? "auto" : "90%",
                  maxHeight: windowWidth <= 768 ? "none" : "90%",
                  margin: windowWidth <= 768 ? "10px" : "2%",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  overflowX: "hidden",
                  overflowY: windowWidth <= 768 ? "visible" : "auto",
                  width: windowWidth <= 768 ? "calc(100% - 20px)" : "100%",
                  maxWidth: "100%",
                  boxSizing: "border-box",
                  paddingBottom: windowWidth <= 768 ? "10px" : "0",
                }}
              >
                <div style={{ 
                  height: "auto", 
                  minWidth: windowWidth <= 768 ? "100%" : "600px",
                  width: "100%",
                  maxWidth: "100%",
                  boxSizing: "border-box",
                  flex: windowWidth <= 768 ? "0 1 auto" : "1 1 auto",
                  overflowY: windowWidth <= 768 ? "visible" : "auto",
                  maxHeight: windowWidth <= 768 ? "none" : "calc(90vh - 200px)",
                }}>
                  <br />
                  <div
                    className="shiftDetailsHeader"
                    style={{
                      display: windowWidth <= 768 ? "none" : "flex",
                      justifyContent: "space-between",
                      height: "40px",
                      alignItems: "center",
                      backgroundColor: "rgba(235, 237, 240, 0.34)",
                      margin: windowWidth <= 768 ? "0" : "0 2%",
                      padding: windowWidth <= 768 ? "0" : "0 15px",
                      borderRadius: "10px",
                      minWidth: windowWidth <= 768 ? "100%" : "600px",
                      width: windowWidth <= 768 ? "100%" : "auto",
                      boxSizing: "border-box",
                      gap: "10px"
                    }}
                  >
                    <div style={{ flexBasis: "20%", textAlign: "center", padding: "0 5px" }}>StartDate</div>
                    <div style={{ flexBasis: "20%", textAlign: "center", padding: "0 5px" }}>StartTime</div>
                    <div style={{ flexBasis: "20%", textAlign: "center", padding: "0 5px" }}>EndDate</div>
                    <div style={{ flexBasis: "20%", textAlign: "center", padding: "0 5px" }}>EndTime</div>
                    <div style={{ flexBasis: "20%", textAlign: "center", padding: "0 5px" }}>Total Time</div>
                  </div>
                  <div
                    className="shiftTimingsContainer"
                    style={{
                      minWidth: windowWidth <= 768 ? "100%" : "600px",
                      maxWidth: "100%",
                      overflowX: windowWidth <= 768 ? "visible" : "auto",
                      width: "100%",
                      boxSizing: "border-box",
                      padding: windowWidth <= 768 ? "0 5px" : "0"
                    }}
                  >
                    {shiftTimings?.map((val, index) => {
                      const startDateTime = new Date(
                        `${val?.startDate} ${val?.startTime}`
                      );
                      const endDateTime = new Date(
                        `${val?.endDate} ${val?.endTime}`
                      );
                      const timeDiff = Math.abs(endDateTime - startDateTime);
                      const totalHours = Math.floor(
                        timeDiff / (1000 * 60 * 60)
                      );
                      const totalMinutes = Math.floor(
                        (timeDiff % (1000 * 60 * 60)) / (1000 * 60)
                      );
                      const totalTime = `${totalHours}hr ${totalMinutes}min`;
                      return (
                        <React.Fragment key={index}>
                          <div
                            className="shiftDetailsRow"
                            style={{
                              display: "flex",
                              flexDirection: windowWidth <= 768 ? "column" : "row",
                              alignItems: windowWidth <= 768 ? "stretch" : "center",
                              justifyContent: windowWidth <= 768 ? "flex-start" : "space-between",
                              gap: windowWidth <= 768 ? "0" : "10px",
                              width: "100%",
                              maxWidth: "100%",
                              minWidth: windowWidth <= 768 ? "100%" : "600px",
                              padding: windowWidth <= 768 ? "15px" : "0",
                              margin: windowWidth <= 768 ? "10px 0" : "0",
                              marginLeft: windowWidth <= 768 ? "0" : "auto",
                              marginRight: windowWidth <= 768 ? "0" : "auto",
                              backgroundColor: windowWidth <= 768 ? "#f8f9fa" : "transparent",
                              borderRadius: windowWidth <= 768 ? "8px" : "0",
                              position: "relative",
                              boxSizing: "border-box",
                            }}
                          >
                            {/* Row 1: Dates (Start Date and End Date side by side on mobile) */}
                            {windowWidth <= 768 ? (
                              <div style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "10px",
                                width: "100%",
                                marginBottom: "10px",
                                boxSizing: "border-box"
                              }}>
                                <div
                                  style={{ 
                                    width: "48%",
                                    boxSizing: "border-box"
                                  }}
                                  id={index + "date"}
                                  onChange={(e) =>
                                    shiftRowValueChangeHandler(e, index)
                                  }
                                >
                                  <label style={{ 
                                    display: "block", 
                                    marginBottom: "5px", 
                                    fontSize: "12px", 
                                    fontWeight: "500",
                                    color: "#666"
                                  }}>
                                    Start Date
                                  </label>
                                  <input
                                    name="startDate"
                                    type="date"
                                    value={val.startDate}
                                    style={{ 
                                      width: "100%",
                                      maxWidth: "100%",
                                      padding: "8px",
                                      border: "1px solid #ddd",
                                      borderRadius: "4px",
                                      backgroundColor: "white",
                                      boxSizing: "border-box"
                                    }}
                                  />
                                </div>
                                <div
                                  style={{ 
                                    width: "48%",
                                    boxSizing: "border-box"
                                  }}
                                  id={index + "endDate"}
                                  onChange={(e) =>
                                    shiftRowValueChangeHandler(e, index)
                                  }
                                >
                                  <label style={{ 
                                    display: "block", 
                                    marginBottom: "5px", 
                                    fontSize: "12px", 
                                    fontWeight: "500",
                                    color: "#666"
                                  }}>
                                    End Date
                                  </label>
                                  <input
                                    name="endDate"
                                    value={val.endDate}
                                    type="date"
                                    style={{ 
                                      width: "100%",
                                      maxWidth: "100%",
                                      padding: "8px",
                                      border: "1px solid #ddd",
                                      borderRadius: "4px",
                                      backgroundColor: "white",
                                      boxSizing: "border-box"
                                    }}
                                  />
                                </div>
                              </div>
                            ) : (
                              <>
                                <div
                                  style={{ 
                                    width: "20%",
                                    marginRight: "15px",
                                    boxSizing: "border-box",
                                    padding: "0 5px"
                                  }}
                                  id={index + "date"}
                                  onChange={(e) =>
                                    shiftRowValueChangeHandler(e, index)
                                  }
                                >
                                  <input
                                    name="startDate"
                                    type="date"
                                    value={val.startDate}
                                    style={{ 
                                      width: "100%",
                                      maxWidth: "100%",
                                      padding: "6px 8px",
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "4px",
                                      backgroundColor: "white",
                                      boxSizing: "border-box",
                                      fontSize: "14px"
                                    }}
                                  />
                                </div>
                              </>
                            )}

                            {/* Row 2: Start Time (full width on mobile) */}
                            <div
                              style={{ 
                                width: windowWidth <= 768 ? "100%" : "20%",
                                minWidth: windowWidth <= 768 ? "100%" : "auto",
                                maxWidth: windowWidth <= 768 ? "100%" : "20%",
                                marginBottom: windowWidth <= 768 ? "10px" : "0",
                                marginRight: windowWidth <= 768 ? "0" : "15px",
                                boxSizing: "border-box",
                                padding: windowWidth <= 768 ? "0" : "0 5px"
                              }}
                              id={index + "time"}
                              onChange={(e) =>
                                shiftRowValueChangeHandler(e, index)
                              }
                            >
                              {windowWidth <= 768 && (
                                <label style={{ 
                                  display: "block", 
                                  marginBottom: "5px", 
                                  fontSize: "12px", 
                                  fontWeight: "500",
                                  color: "#666"
                                }}>
                                  Start Time
                                </label>
                              )}
                              <input
                                name="startTime"
                                value={val.startTime}
                                style={{
                                  color: "rgba(42, 149, 69, 255)",
                                  backgroundColor: windowWidth <= 768 ? "white" : "rgba(42, 149, 69, 0.14)",
                                  padding: windowWidth <= 768 ? "8px" : "8px 12px",
                                  borderRadius: "10px",
                                  width: "100%",
                                  maxWidth: "100%",
                                  border: windowWidth <= 768 ? "1px solid rgba(42, 149, 69, 0.3)" : "none",
                                  boxSizing: "border-box",
                                  fontSize: "14px"
                                }}
                                type="text"
                                onFocus={(e) => (e.target.type = "time")}
                                onBlur={(e) => (e.target.type = "text")}
                              />
                            </div>

                            {/* Row 3: End Date (desktop only, appears after Start Time) */}
                            {windowWidth <= 768 ? null : (
                              <div
                                style={{ 
                                  width: "20%",
                                  marginRight: "15px",
                                  boxSizing: "border-box",
                                  padding: "0 5px"
                                }}
                                id={index + "endDate"}
                                onChange={(e) =>
                                  shiftRowValueChangeHandler(e, index)
                                }
                              >
                                <input
                                  name="endDate"
                                  value={val.endDate}
                                  type="date"
                                  style={{ 
                                    width: "100%",
                                    maxWidth: "100%",
                                    padding: "6px 8px",
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "4px",
                                    backgroundColor: "white",
                                    boxSizing: "border-box",
                                    fontSize: "14px"
                                  }}
                                />
                              </div>
                            )}

                            {/* Row 4: End Time (full width on mobile) */}
                            <div
                              style={{ 
                                width: windowWidth <= 768 ? "100%" : "20%",
                                minWidth: windowWidth <= 768 ? "100%" : "auto",
                                maxWidth: windowWidth <= 768 ? "100%" : "20%",
                                marginBottom: windowWidth <= 768 ? "10px" : "0",
                                marginRight: windowWidth <= 768 ? "0" : "15px",
                                boxSizing: "border-box",
                                padding: windowWidth <= 768 ? "0" : "0 5px"
                              }}
                              id={index + "endTime"}
                              onChange={(e) =>
                                shiftRowValueChangeHandler(e, index)
                              }
                            >
                              {windowWidth <= 768 && (
                                <label style={{ 
                                  display: "block", 
                                  marginBottom: "5px", 
                                  fontSize: "12px", 
                                  fontWeight: "500",
                                  color: "#666"
                                }}>
                                  End Time
                                </label>
                              )}
                              <input
                                name="endTime"
                                value={val.endTime}
                                style={{
                                  color: "rgb(226, 44, 29)",
                                  backgroundColor: windowWidth <= 768 ? "white" : "rgba(226, 44, 29, 0.14)",
                                  padding: windowWidth <= 768 ? "8px" : "8px 12px",
                                  borderRadius: "10px",
                                  width: "100%",
                                  maxWidth: "100%",
                                  border: windowWidth <= 768 ? "1px solid rgba(226, 44, 29, 0.3)" : "none",
                                  boxSizing: "border-box",
                                  fontSize: "14px"
                                }}
                                type="text"
                                onFocus={(e) => (e.target.type = "time")}
                                onBlur={(e) => (e.target.type = "text")}
                              />
                            </div>

                            {/* Row 4: Total Time (full width on mobile) */}
                            <div
                              style={{ 
                                width: windowWidth <= 768 ? "100%" : "20%",
                                minWidth: windowWidth <= 768 ? "100%" : "auto",
                                maxWidth: windowWidth <= 768 ? "100%" : "20%",
                                flexBasis: windowWidth <= 768 ? "100%" : "20%", 
                                textAlign: windowWidth <= 768 ? "left" : "center",
                                marginBottom: windowWidth <= 768 ? "10px" : "0",
                                marginRight: windowWidth <= 768 ? "0" : "15px",
                                boxSizing: "border-box",
                                padding: windowWidth <= 768 ? "0" : "0 5px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: windowWidth <= 768 ? "flex-start" : "center"
                              }}
                            >
                              {windowWidth <= 768 && (
                                <label style={{ 
                                  display: "block", 
                                  marginBottom: "5px", 
                                  fontSize: "12px", 
                                  fontWeight: "500",
                                  color: "#666"
                                }}>
                                  Total Time
                                </label>
                              )}
                              <p
                                style={{
                                  borderRadius: "10px",
                                  marginTop: windowWidth <= 768 ? "0" : "15px",
                                  marginLeft: windowWidth <= 768 ? "0" : "5px",
                                  display: "inline-block",
                                  backgroundColor: windowWidth <= 768 ? "#e3f2fd" : "transparent",
                                  padding: windowWidth <= 768 ? "8px 12px" : "4px",
                                }}
                              >
                                {totalTime}
                              </p>
                            </div>

                            {/* Row 5: Delete button (full width on mobile) */}
                            {windowWidth <= 768 ? (
                              <div style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "5px"
                              }}>
                                <AiOutlineDelete
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    color: "#d32f2f"
                                  }}
                                  onClick={() => shiftRowCancelHandler(index)}
                                />
                              </div>
                            ) : (
                              <div style={{
                                width: "auto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "0 5px"
                              }}>
                                <AiOutlineDelete
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "36px",
                                    color: "#d32f2f",
                                    padding: "5px"
                                  }}
                                  onClick={() => shiftRowCancelHandler(index)}
                                />
                              </div>
                            )}
                          </div>
                          <hr style={{ margin: "2%", borderTop: "#f3f6f9" }} />
                        </React.Fragment>
                      );
                    })}
                  </div>
                  {formError.shiftTimingsError && (
                    <p
                      style={{
                        color: "red",
                        textAlign: "left",
                        padding: "20px",
                      }}
                    >
                      {"*" + formError.shiftTimingsError}
                    </p>
                  )}
                </div>
                <div style={{
                  position: windowWidth <= 768 ? "sticky" : "relative",
                  bottom: windowWidth <= 768 ? "0" : "auto",
                  backgroundColor: windowWidth <= 768 ? "white" : "transparent",
                  padding: windowWidth <= 768 ? "10px" : "0",
                  marginTop: windowWidth <= 768 ? "10px" : "auto",
                  zIndex: windowWidth <= 768 ? "10" : "auto",
                  boxShadow: windowWidth <= 768 ? "0 -2px 10px rgba(0,0,0,0.1)" : "none",
                }}>
                  <button
                    className="shiftSaveButton"
                    onClick={() => setIsShiftSaveClicked(true)}
                    style={{
                      width: windowWidth <= 768 ? "100%" : undefined,
                      padding: windowWidth <= 768 ? "12px 20px" : undefined,
                      fontSize: windowWidth <= 768 ? "16px" : undefined,
                      fontWeight: windowWidth <= 768 ? "500" : undefined,
                      margin: windowWidth <= 768 ? "0" : undefined,
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {isLoading && (isShiftSaveClicked || shiftId) && (
        <img src={loadingGif} className="loading-gif" />
      )}
      {isShiftCreationSuccess && (
        <Message
          type={isShiftCreationSuccess}
          driveErrorMessage={
            isShiftCreationSuccess?.toLowerCase()?.includes("greater")
              ? "Shift End Time should be greater than Current Time/ Start Time"
              : ""
          }
          message={
            selectedDrivers.length > 0
              ? selectedDrivers.map(d => d.name).join(", ") + "'s shift has been created Successfully"
              : driverNameRef.current.value + "'s shift has been created Successfully"
          }
          onAddAnother={() => window.location.reload()}
          // Pass a custom function for the "OK" button
          onOk={() => history.push("/privatedrive/shifts")}
          showAddAnotherButton={true}
          showAddAnotherButtonText={"Add Another Shift"}
        />
      )}
    </div>
  );
};

export default ShiftCreation;
